module.exports = __webpack_public_path__ + "static/media/trash.f7aa43a0.svg";